<template>
  <div>
    <section class="hero is-light">
      <div class="hero-body">
        <div class="container">
          <nav class="level is-mobile">
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Ofertas de Empleo</p>
                <p class="title">{{ vacancies.length }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <img :src="logo" alt="Croc Cancún"/>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Puestos</p>
                <p class="title">{{ vacancies.length }}</p>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </section>
    <div class="container">
      <div class="columns mt-01">
        <div class="column is-10">
          <swiper :options="swiperOption">
            <swiper-slide v-for="(vacancies, i) in chunkedVacantes" :key="i">
              <table class="table table is-fullwidth table is-striped table is-bordered">
                <thead>
                  <tr>
                    <th>Hotel</th>
                    <th>Experiencia</th>
                    <th>Puesto</th>
                  </tr>
                </thead>
                <tfoot>
                  <tr>
                    <th>Hotel</th>
                    <th>Experiencia</th>
                    <th>Puesto</th>
                  </tr>
                </tfoot>
                <tbody>
                  <tr v-for="(v, i) in vacancies">
                    <td>{{v.company}}</td>
                    <td>{{v.demand}}</td>
                    <td>{{v.job}}</td>
                  </tr>
                </tbody>
              </table>
            </swiper-slide>
          </swiper>
        </div>
        <div class="column is-2">
          <img :src="vacantesimg" alt="Croc Cancún"/>
        </div>

      </div>

    </div>


  </div>
</template>

<script>
import axios from 'axios';
import VueLodash from 'vue-lodash'
import bannervacantes from '@/assets/img/bannervacantes.jpg'
import logo from '@/assets/img/logo.png'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'VacantesFullPage',
  data () {
    return {
      vacancies:[],
      countVacancies:0,
      vacantesimg:bannervacantes,
      logo:logo,
      swiperOption: {
        centeredSlides: true,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false
        },
      }
    }
  },
  components: {
    swiper,
    swiperSlide,
  },
  watch: {
  },
  computed: {
    chunkedVacantes () {
      return _.chunk(this.vacancies,6)
    }
  },
  methods:{
    vacanciesSearch(){
      var self = this;
      axios.get(process.env.API_URL_V1+'vacancies?api_token='+process.env.API_TOKEN_V1)
      .then(function (response) {
        self.vacancies=response.data.data;
      })
      .catch(function (error) {
      });
    },
  },
  created :function(){
    this.vacanciesSearch();
  }
}
</script>

<style scoped>
.filter-img{

}
thead,tfoot,th{
  background-color: rgba(177,59,61,1);
  color:#ffffff !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/VacantesFullPage.vue